module.exports = __webpack_public_path__ + "img/product-s618-2000-1.eec97b0c.png";